/**
 * Chart colors palette
 */
export default {
  chartBackground: "#fff",
  tooltipBackground: "#173755",
  rangeSelectorButtonBackground: "#173755",
  rangeSelectorButtonBackgroundHover: "#173755",
  rangeSelectorButtonBackgroundSelect: "#173755",
  rangeSelectorButtonColor: "#fff",
  contrastTextColor: "#fff",
  textColor: "#161e3a",
  axisLineColor: "#eaebf2"
}
